import React from "react";
//components
import { Row } from "../../../../../../../components/Layout/Grid";
import { TableHeaderContent } from "./styles";
import { HeaderText } from "../style";

export const TableHeader = () => {
  return (
    <TableHeaderContent>
      <Row className="headerTitle">
        <Row>
          <HeaderText>
            <em>Preço praticado em cotação (Top 20)</em>
          </HeaderText>
        </Row>
        <Row>
          <span>Clique no valor para aplicar</span>
        </Row>
      </Row>
      <Row className="headerTitle">
        <Row>
          <HeaderText>
            <em>Preço de venda (Top 20)</em>
          </HeaderText>
        </Row>
        <Row>
          <span>Clique no valor para aplicar</span>
        </Row>
      </Row>
    </TableHeaderContent>
  );
};